import React from "react";
import ReactDOM from 'react-dom';
import axios from 'axios';
import useSWR from 'swr'
import Spinner from "./components/Spinner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Image from "./components/Image";
import Breadcrumb from "./components/Breadcrumb";
import './../sass/style.scss';
import 'swiper/css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import { faFacebookF, faInstagram, faTwitter } from "@fortawesome/free-brands-svg-icons";
import SidebarReferences from "./components/SidebarReferences";

const url = window.location.pathname;
const fetcher = url => axios.get(url).then(res => res.data)

function Services() {
    const { data, error } = useSWR('https://www.bwa.com.tr/api'+url, fetcher)

    return data ? (
    <>
    <Header data={data.header} inPage={true} />
    <Breadcrumb background={data.page.file2} title={data.page.category_language.name}>
        {data.breadcrumb.map((item,index) => {
            return <li key={index}> <a href={item[1]}>{item[0]}</a> </li>
        })}
    </Breadcrumb>

    <div className="articles container">
        <div className="row">
            <div className="col-xl-8">
                <section className="article-detail">
                    <div className="article-image">
                        <span><FontAwesomeIcon icon={faCalendarAlt} /> { data.page.category_language.extra?.date }</span>
                        {data.page?.file3 && (<Image image={data.page.file3} alt={data.page.category_language.alt?.file3} />)}
                    </div>
                    <h1>{data.page.category_language.description}</h1>
                    <div dangerouslySetInnerHTML={{ __html: data.page.category_language.contents }}></div>
                </section>
                <div className="articles-extra">
                    <div className="tags">
                        <span><i className="fas fa-tag"></i> Tag:</span>
                        {data.page.tags?.map((item,index) => {
                            return <a href={"/tags/"+item.slug} key={index}>
                            {item.name}
                        </a>
                        })}
                    </div>
                    <div className="socials">
                        <a href={data.page.socials.facebook} target="_blank"><FontAwesomeIcon icon={faFacebookF} /></a>
                        <a href={data.page.socials.instagram} target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
                        <a href={data.page.socials.twitter} target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
                    </div>
                </div>

            </div>
            <div className="col-xl-4">
                <div className="sidebar">
                    <div className="last-articles">
                        <h1>{translations.services}</h1>
                        {data.services.map((item,index) => {
                            return <a href={item.category_language.taxonomy} key={index}>
                            <div className="image">
                                <img src={item.file3} alt={item.category_language.alt?.file3} />
                            </div>
                            <div>
                                <h4>
                                    {item.category_language.name}
                                </h4>
                                <p>
                                    {item.category_language.description}
                                </p>
                            </div>
                        </a>
                        })}
                    </div>
                    <SidebarReferences data={data.references} />
                </div>
            </div>
        </div>
    </div>

    <Footer data={data.footer} inPage={true} />
    </>
    ) : <Spinner />;
}

ReactDOM.render(
  <Services />,
  document.getElementById('root')
);
